export default {
  id: 'socialHousingLoan',
  idHr: 'SV',
  url: 'social-housing-loan',
  title: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_LOAN',
  titleSecondary: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_LOAN',
  img: 'img/loans/loans-catalog/house-social.png',
  header: 'img/loans/loans-catalog/house-social-header.png',
  minMonthlyFeeDivider: 360,
  signUp: {
    deadline: 360,
    interestRate: 0,
    annualPercentageRate: 0,
    mandatoryInsurance: true,
    tooltipId: 'SOCIAL_HOUSING_LOAN',
  },
  detail: {
    title: 'LOANS.LOANS_CATALOG.CARDS.SOCIAL_HOUSING_LOAN',
    basicCharacteristics: [
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE1',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG1',
        amountMax: [
          {
            title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_TITLE',
            paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1',
            list: [
              {
                text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM1',
                link: 'my-creditworthiness',
                textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM1_TEXTLINK',
              },
              {
                text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_ITEM2',
              },
            ],
            info: [
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH1_INFO',
            ],
          },
          {
            title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_TITLE',
            list: [
              {
                text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM1',
                link: 'my-creditworthiness',
                textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM1_TEXTLINK',
              },
              {
                text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_ITEM2',
              },
            ],
            info: [
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_INFO',
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH2_INFO2',
            ],
          },
        ],
        paragraphs: [
          'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH3',
          'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.PARAGRAPH4',
        ],
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE3',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3',
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE11',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG11',
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE4',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4',
        hasMargin: true,
        typeInterest: [
          {
            formula: {
              title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_TEXT',
              nominator: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_2',
              denominator: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_3',
              coefficient: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_FORMULA_1',
            },
            table: {
              title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_CALC',
              items: {
                header: [
                  'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER1',
                  'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER2',
                ],
              },
              paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT',
              titleTable: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT_TABLE',
            },
          },
        ],
        textToCatalog: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT',
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE10',
        desc: [
          'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG10_1',
          'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG10_2',
        ],
        hasMargin: true,
        typeInterestFixed: [
          {
            table: {
              title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_CALC',
              items: {
                header: [
                  'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER1',
                  'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TABLE_HEADER2',
                ],
              },
              paragraph: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT',
              titleTable: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG4_TEXT_TABLE_FIXED',
            },
          },
        ],
        textToCatalog: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT',
      },
      {
        hasMargin: true,
        desc: [
          {
            text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG12_1',
            textRedirect: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG12_2',
            redirect: 'https://bbva-tuybbva-portales.appspot.com/acuerdos-de-empresas/',
          },
        ],
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE2',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG2',
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE5',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG5',
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE6',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG6',
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE7',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG7',
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE8',
        desc: [
          'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG8_1',
          'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG8_2',
        ],
      },
      {
        title: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.TITLE9',
        desc: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG9_1',
        dataLink: {
          text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG9_2',
          link: 'my-creditworthiness',
          textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.BASIC_CHARACTERISTICS.MSG9_2_TEXTLINK',
        },
      },
    ],
    requestIt: [
      {
        items: [
          {
            text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM1_TEXT1',
            link: 'my-creditworthiness',
            textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM1_TEXTLINK',
          },
          {
            text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM2_TEXT1',
            link: 'sign-up',
            textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM2_TEXTLINK',
          },
          {
            text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM3_TEXT1',
            link: 'need-a-loan',
            textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH1.ITEM3_TEXTLINK',
          },
        ],
        otherItems: [
          {
            text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT',
          },
          {
            text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM2_TEXT',
            items: [
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM2_LIST1',
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM2_LIST2',
            ],
          },
          {
            text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM3_TEXT',
            link: 'my-loans',
            textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.REQUEST_IT.PARAGRAPH2.ITEM3_TEXTLINK',
          },
        ],
      },
    ],
    prepayments: [
      {
        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH1',
      },
      {
        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3',
        boldText: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_BOLD_1',
        text2: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_1',
        boldText2: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_BOLD_2',
        link: 'my-loans',
        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_TEXTLINK',
        text3: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.PREPAYMENTS.PARAGRAPH3_2',
      }
    ],
    newCreditCapacity: [
      {
        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.NEW_CREDIT_CAPACITY.PARAGRAPH1',
        link: 'need-a-loan',
        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.NEW_CREDIT_CAPACITY.PARAGRAPH1_TEXTLINK',
      }
    ],
    sendDocumentation: [
      {
        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH1',
        textLink: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH1_TEXTLINK',
        link: 'https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20',
        text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_2',
        especifications: [
          {
            dt: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH2',
            dd: [
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH2_ITEM1',
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH2_ITEM2',
            ],
          },
          {
            dt: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3',
            dd: [
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3_ITEM1',
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3_ITEM2',
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3_ITEM3',
              'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH3_ITEM4',
            ],
          },
        ],
      },
      {
        text: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.SEND_DOCUMENTATION.PARAGRAPH4',
        textLink: 'KB0025986',
        link: 'https://bbvatyc.service-now.com/saeesp?id=bbva_kb_article&sys_id=76a180efdb286f00a6148c994b96194b'
      },
    ],
    finishDeadline: 'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.FINISH_DEADLINE',
    statementIncome: [
      'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.STATEMENT_INCOME.PARAGRAPH1',
      'LOANS.LOANS_DETAIL.SOCIAL_HOUSING_LOAN.STATEMENT_INCOME.PARAGRAPH2',
    ],
  },
  legalConditions: {
    clause: {
      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.TITLE',
      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.PARAGRAPH',
      items: [
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM1',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM2',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM3',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM4',
      ],
    },
    declaration: {
      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.TITLE',
      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH',
      items: [
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM1',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM2',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM3',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM4',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM5',
      ],
      itemTerm: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.ITEM_TERM',
      info: [
        {
          text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO',
          items: [
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM1',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM2',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.INFO_ITEM3',
          ],
        },
      ],
      authorization: {
        paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2',
        items: [
          'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM1',
          'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM2',
        ],
      },
    },
  },
};



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/static/socialHousingLoan.js